var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",attrs:{"id":"extended-img"}},[_c('img',{ref:"image",class:{
      'landscape': _vm.isLandscape,
      'cover': _vm.size && _vm.size === 'cover',
      'contain': _vm.size && _vm.size ==='contain'
    },attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }